import { useEffect, useState } from 'react';
import { TPA_EXPERIMENTS } from '@wix/pricing-plans-common/experiments';
import { useExperiments } from '@wix/yoshi-flow-editor';

export function useGoToCheckoutLoading({
  isOnEcom,
  resetLoadingState,
}: {
  isOnEcom: boolean;
  resetLoadingState?(): void;
}) {
  const [isGoToCheckoutLoading, setIsGoToCheckoutLoading] = useState(false);
  const { experiments } = useExperiments();

  useEffect(() => {
    if (experiments.enabled(TPA_EXPERIMENTS.IMPROVE_ECOM_LOADING_STATE) && isOnEcom) {
      return;
    }

    let timeout: ReturnType<typeof setTimeout>;
    if (isGoToCheckoutLoading) {
      /*
        Reset loading state automatically after 5 seconds
        in case checkout is on the same page as PlanList widget
        and component isn't destroyed on navigation
      */
      timeout = setTimeout(() => {
        setIsGoToCheckoutLoading(false);
      }, 5000);
    }

    return () => {
      clearTimeout(timeout);
    };
  }, [experiments, isGoToCheckoutLoading, isOnEcom]);

  useEffect(() => {
    if (!experiments.enabled(TPA_EXPERIMENTS.RESET_CTA_LOADER_ON_BFCACHE)) {
      return;
    }

    /*
      When the user returns from checkout or plan customization with the browser "back" button,
      the page can be restored from bfcache without remounting, keeping the CTA loaders on.
    */
    const onPageShow = (event: PageTransitionEvent) => {
      if (event.persisted) {
        setIsGoToCheckoutLoading(false);
        resetLoadingState?.();
      }
    };

    window.addEventListener('pageshow', onPageShow);
    return () => window.removeEventListener('pageshow', onPageShow);
  }, [experiments, resetLoadingState]);

  return { isGoToCheckoutLoading, setIsGoToCheckoutLoading };
}
